import { api } from '@/core/lib/api-client';
import { GetLinkieDto, LinkInBioDto, ResponseType } from '@link-in-bio/domain';

export const getLinkie = ({ username, domain }: GetLinkieDto): Promise<ResponseType<LinkInBioDto>> => {
  return api.get(`/link-in-bio/linkie?username=${username}&domain=${domain}`);
};
